export default (item) => {
  return {
    id: item.id,
    label: item.label,
    parentId: item.parentId ?? null,
  }
}
